'use strict';

var propTypes = require('./prop-types.js');
var canUseDom = require('./can-use-dom.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('exenv');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Get the HTMLElement constructor in safety mode.
 *
 * @function
 * @returns {HTMLElement} Returns the HTMLElement constructor, empty object otherwise.
 * @example
 * getSafeHTMLElement();
 */

var getSafeHTMLElement = function getSafeHTMLElement() {
  return canUseDom() ? window.HTMLElement : {};
};

getSafeHTMLElement.HELPER_ID = 'Gearz.JsUtils.getSafeHTMLElement';
getSafeHTMLElement.returnType = propTypes.funcWithDescription('Returns the HTMLElement constructor, empty object otherwise.');
getSafeHTMLElement.parameterTypes = {};
getSafeHTMLElement.defaultParameters = {};

module.exports = getSafeHTMLElement;
